// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { VueFire, VueFireAuth } from 'vuefire'
import {
  GoogleAuthProvider,
  signInWithPopup as _signInWithPopup,
  signOut as _signOut,
  getAuth
} from 'firebase/auth'
import { ref } from 'vue'
import type { Ref } from 'vue'

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyBTcQ2P1mmXzmHMH82ISDl4M0SWdIg4hdU',
  authDomain: 'brunomiguelbarrospinto-caf9c.firebaseapp.com',
  databaseURL:
    'https://brunomiguelbarrospinto-caf9c-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'brunomiguelbarrospinto-caf9c',
  storageBucket: 'brunomiguelbarrospinto-caf9c.firebasestorage.app',
  messagingSenderId: '228708649275',
  appId: '1:228708649275:web:88ace1531cc0977780cf1e'
}

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig)

// Initialize VueFire with the Firebase app
function appUseFirebaseApp(app: any) {
  app.use(VueFire, {
    // imported above but could also just be created here
    firebaseApp,
    modules: [
      // we will see other modules later on
      VueFireAuth()
    ]
  })
}

const currentAuthUser: Ref<any | null> = ref(null)

export const useFirebase = (): {
  setCurrentAuthUser: (authUser: any | null) => void
  currentAuthUser: Ref<any | null>
  signInWithPopup: (platform: string) => Promise<void>
  signOut: () => void
} => {
  function setCurrentAuthUser(authUser: any | null): void {
    currentAuthUser.value = authUser
  }

  async function signInWithPopup(platform: string): Promise<void> {
    const auth = getAuth()
    if (platform === 'google') {
      const provider = new GoogleAuthProvider()
      const response = await _signInWithPopup(auth, provider)
      setCurrentAuthUser(response.user)
    }
  }

  async function signOut(): Promise<void> {
    const auth = getAuth()
    await _signOut(auth)
  }

  return {
    setCurrentAuthUser,
    currentAuthUser,
    signInWithPopup,
    signOut
  }
}

export { firebaseApp, appUseFirebaseApp }
